// 광역시·도 옵션 (받은요청 필터/마이페이지 지역 선택에서 공통 사용)
export const REGION_OPTIONS = [
  "전국",
  "서울",
  "부산",
  "대구",
  "인천",
  "광주",
  "대전",
  "울산",
  "세종",
  "경기",
  "강원",
  "충북",
  "충남",
  "전북",
  "전남",
  "경북",
  "경남",
  "제주",
];

// 백엔드 buildRegionFilter 와 동일한 alias 매핑 (필요 시 클라이언트에서도 사용)
export const REGION_ALIASES = {
  서울: ["서울"],
  부산: ["부산"],
  대구: ["대구"],
  인천: ["인천"],
  광주: ["광주"],
  대전: ["대전"],
  울산: ["울산"],
  세종: ["세종"],
  경기: ["경기"],
  강원: ["강원"],
  제주: ["제주"],
  충북: ["충북", "충청북도"],
  충남: ["충남", "충청남도"],
  전북: ["전북", "전라북도"],
  전남: ["전남", "전라남도"],
  경북: ["경북", "경상북도"],
  경남: ["경남", "경상남도"],
};

// 주소 문자열에서 지역(광역시·도)을 추출. 매칭 안 되면 빈 문자열.
export function inferRegionFromAddress(addr) {
  if (!addr) return "";
  const s = String(addr);
  for (const region of REGION_OPTIONS) {
    if (region === "전국") continue;
    const aliases = REGION_ALIASES[region] || [region];
    if (aliases.some((a) => s.includes(a))) return region;
  }
  return "";
}

// URL ?region=대전,부산 같은 CSV 를 배열로 (빈 값/"전국" 은 빈 배열로).
export function parseRegionCsv(raw) {
  if (!raw) return [];
  return String(raw)
    .split(",")
    .map((v) => v.trim())
    .filter((v) => v && v !== "전국");
}

// 주소가 지역 배열 중 하나라도 매칭되면 true. 배열이 비어있으면 항상 true(필터 미적용).
export function addressMatchesAny(addr, regions) {
  if (!Array.isArray(regions) || regions.length === 0) return true;
  const s = String(addr || "");
  return regions.some((r) => {
    const aliases = REGION_ALIASES[r] || [r];
    return aliases.some((a) => s.includes(a));
  });
}
